export const getTimeStampCorregidoZonaHoraria = (fecha, timeZone) => {
  const newDate = new Date(fecha.getTime());
  const timeWithZoneFromExcel = new Date(fecha.getTime()).toLocaleString("en-ES", {
    timeZone: timeZone,
  });

  const timestampFromExcel = new Date(timeWithZoneFromExcel);

  // timestampFromExcel.setMilliseconds(0);
  // timestampFromExcel.setSeconds(0);

  const difHours = Math.round(
    newDate.getTime() - timestampFromExcel.getTime()
  );
  const hoursDate = fecha.getTime() + difHours;

  return hoursDate;
}
/**
 * Corrige el timestamp de la fecha de la cita segun la zona horaria de Colombia y Chile
 * @param {Date} fecha fecha de la cita
 * @param {int} timeZone zona horaria de la cita
 * @returns timestamp corregido de la fecha de la cita. Si la fecha es null, retorna null
 */
export const getTimeStampCorregidoZonaHorariaCH = (fecha, timeZone) => {
  const newDate = new Date(fecha.getTime());
  const timeWithZoneFromExcel = new Date(fecha.getTime()).toLocaleString("en-ES", {
    timeZone: timeZone,
  });
  const timestampFromExcel = new Date(timeWithZoneFromExcel);
  const difHours = Math.round(
    newDate.getTime() - timestampFromExcel.getTime()
  );
  const hoursDate = fecha.getTime() - difHours;
  return hoursDate;
}

export const getDateCorregidoZonaHoraria = (fecha, timeZone) => {
  const newDate = new Date(fecha.getTime());
  const timeWithZoneFromExcel = new Date(fecha.getTime()).toLocaleString("en-ES", {
    timeZone: timeZone,
  });

  const timestampFromExcel = new Date(timeWithZoneFromExcel);

  // timestampFromExcel.setMilliseconds(0);
  // timestampFromExcel.setSeconds(0);

  const difHours = Math.round(
    newDate.getTime() - timestampFromExcel.getTime()
  );
  const hoursDate = fecha.getTime() + difHours;

  return new Date(hoursDate);
}

export const diferenceBetweenTimeZoneMiliseconds = (timeZone) => {
  const newDate = new Date();
  const timeWithZone = new Date().toLocaleString("en-ES", {
    timeZone: timeZone,
  });

  const timestamp = new Date(timeWithZone);

  const difHours = Math.round(
    newDate.getTime() - timestamp.getTime()
  );

  return difHours
}